module.exports = __webpack_public_path__ + "img/reports_sidebar.593d65e2.svg";